export default "__VITE_ASSET__B2X0uFNM__"